import { Utils } from '@genial/utils';

import { RiskRating } from '../../../../../../../../../components/RiskRating';
import { FixedIncomeOfferEntityNormalized } from '../../../../../../../../../store/product/types';

const formatDateWithDaysRemaining = (date: Date) => {
  const daysRemaining = Utils.Date.DaysDifferenceFromToday(date);
  const dateFormatted = Utils.Mask.DateFormat(date, 'dd/MM/yyyy');
  if (daysRemaining > 1) {
    return `${dateFormatted} (${daysRemaining} ${daysRemaining > 1 ? 'dias' : 'dia'})`;
  }
  return `${dateFormatted}`;
};

export const formatFixedIncomeDetailsData = (data: FixedIncomeOfferEntityNormalized) => {
  const maturityDateFormatted = data.maturityDate
    ? formatDateWithDaysRemaining(data.maturityDate)
    : '';
  const applicationMinimumAmountFormatted = Utils.Mask.Money(data.applicationMinimumAmount);
  const dueDateFormatted = data.dueDate ? formatDateWithDaysRemaining(data.dueDate) : '';
  const applicationMaximumAmountFormatted = Utils.Mask.Money(data.applicationMaximumAmount);
  const unitPriceFormatted = Utils.Mask.Money(data.unitPrice);
  const profitabilityDailyFormatted = Utils.Mask.Percentage(data.profitabilityDaily);
  const profitabilityYearlyFormatted = Utils.Mask.Percentage(data.profitabilityYearly);
  const profitabilityToMaturityFormatted = Utils.Mask.Percentage(data.profitabilityToMaturity);

  const dataFormatted = [
    {
      label: 'Risco',
      valueComponent: (
        <RiskRating
          currentRiskRating={Number(data.riskRatingLevel) || 0}
          tooltip={data.riskRatingName || ''}
        />
      ),
    },
    { label: 'Rating(BR)', value: data.riskRatingNormalized },
    { label: 'Tipo', value: data.profitabilityType || '--' },
    { label: 'Aplicação Mínima', value: applicationMinimumAmountFormatted },
    { label: 'Aplicação Máxima', value: applicationMaximumAmountFormatted },
    { label: 'Preço Unitário', value: unitPriceFormatted },
    { label: 'Taxa', value: data.profitabilityFormattedNormalized },
    { label: 'Liquidez', value: data.liquidityIndicatorNormalized || '--' },
    { label: 'Juros', value: data.feesPayment || '--' },
    { label: 'Vencimento', value: maturityDateFormatted },
    { label: 'Carência', value: dueDateFormatted },
    { label: 'Amortização', value: data.amortizationType || '--' },
    { label: 'Rentabilidade Diária', value: profitabilityDailyFormatted },
    { label: 'Rentabilidade Anual', value: profitabilityYearlyFormatted },
    { label: 'Rentabilidade Até venc.', value: profitabilityToMaturityFormatted },
  ];

  return dataFormatted;
};
